import React , { useState , useRef} from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Page3 from "./Page3";
import Page4 from "./Page4";

const Page5 = () => {
    
    const navigate = useNavigate();
    const location = useLocation();
    const allResults = location.state.allResults;
    
    const binaryInputValue = location.state.binaryInputValue;
    const inputValue = location.state.inputValue;
    const randomNum = location.state.randomNum;
    const roundCount = location.state.roundCount;

    const [counter, setCounter] = useState(roundCount*2);
    const [rond, setrond] = useState(roundCount);
    const RandomAnswer = allResults[randomNum-1][2];
    let answer = allResults[2][2];
    let round = 3

    console.log("allResults:" , allResults)
    console.log("randomNum" , randomNum)
    // Generate a random number between 5 and 15 (inclusive)
    
    console.log('randomNum: ',randomNum);
    console.log('counter: ', counter)
    const decriment = () => {
        console.log(counter)
        if(counter === 0){
            navigate('/page2', { state: { binaryInputValue, inputValue} });
        }
        if(counter%2 === 0){
            setrond(rond - 1);
        }
        setCounter(counter - 1);
    };
  
    const incriment = () => {

        if(counter === 4 ){
            navigate('/page6', { state: { answer , allResults , round , binaryInputValue , inputValue , randomNum} })
        }

        if(counter === randomNum*2-2    ){
            round = randomNum
            answer = RandomAnswer
            navigate('/page6', { state: { answer , allResults , round , binaryInputValue , inputValue , randomNum } })
        }

        if(counter%2 === 1){
            setrond(rond + 1)
        }
        setCounter(counter + 1);

        if(counter === 31){
            navigate("/end")
        }
    };

    const goToStage = (index) => {
        setrond(index);
        setCounter(index * 2);
    };

    return (
        <>
        <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>This page visualises the left shift in the two equal halves of 28 bit each.<br></br>
      Depending on the round, the left shift is performed.<br>
      </br>Rounds 1,2,9 and 16 undergo 1 bit left shift while all other rounds undergo 2 bit left shift.<br></br>
      After the shift, the the equal halves are joined together to undergo compression permutation. The final result of compression 
      permutation gives a 48 bit key.

      </p>
    </div>
       
        {
            (counter%2 === 0) && (
                <div><Page3 round={rond}/></div>
            )
        }
        
        {
            (counter%2 === 1) && (
                <div><Page4 round={rond}/></div>
                
            )
            
        }
        <div className="button-holder pt-64">
            <div className="prev-button" onClick={decriment}>
                PREVIOUS
            </div>
            <div className="circle-container">
                {[...Array(16)].map((_, index) => (
                <div
                    key={index}
                    className={`circle ${index === rond ? 'green' : 'orange'}`}
                    onClick={() => goToStage(index)} 
                >
                    {index + 1}
                </div>
                ))}
            </div>
            <div className="next-button" onClick={incriment}>
                NEXT
                </div>
        </div>
        
        
            
        
        
        </>
    );
};

export default Page5;